export const LIVE_ORIGIN = "https://quiz1.konstantinosgrapsas.com";

export function isPreviewEnvironment() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  if (host === "quiz1.konstantinosgrapsas.com" || host === "konstantinosgrapsas.com") return false;
  return host.includes("preview.emergentagent.com") || host === "localhost";
}

export const liveUrlForCurrentPath = () => `${LIVE_ORIGIN}${typeof window !== "undefined" ? window.location.pathname : ""}`;
